import axios from 'axios'
import Qs from 'qs'
import Cookie from 'js-cookie'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  paramsSerializer: function(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },
})

http.interceptors.request.use(config => {
  const csrfToken = Cookie.get('intranet_csrf_token') || null
  config.headers['X-CSRF-Token'] = csrfToken
  return config
})

http.interceptors.response.use(response => response, ({ response }) => {
  return Promise.reject(response)
})
